import { blurActiveElement } from '@/utils';
import { PLATFORMS, PLATFORM_CAPTIONS } from '@/constants';

const targets = Object.keys(PLATFORMS);

const TargetSelect = ({ id, source, target, disabled, onTargetChange }) => {
  const targetSelectId = `${id}TargetSelect`;

  return (
    <>
      {source && (
        <>
          <div className="input-group mt-3">
            <label
              htmlFor={targetSelectId}
              className="input-group-text shadow-sm"
            >
              Target
            </label>

            <select
              id={targetSelectId}
              disabled={disabled}
              value={target || ''}
              className="form-select border shadow-sm"
              onChange={(e) => {
                blurActiveElement();
                onTargetChange(e.target.value || '');
              }}
            >
              {targets.length > 1 && <option value="">Choose...</option>}

              {targets.map((platform) => (
                <option key={platform} value={platform}>
                  {PLATFORM_CAPTIONS[platform]}
                </option>
              ))}
            </select>
          </div>
        </>
      )}
    </>
  );
};

export default TargetSelect;
